export const productHeaders = [
  "Long Name",
  "Short Name",
  "Barcode",
  "NAPPI Code",
  "Supplier",
  "Status",
];
export const partyHeaders = [
  "Name",
  "Account Code",
  "VAT No",
  "Reg No",
  "Customer",
  "Supplier",
  "Status",
];
export const siteHeaders = ["Name", "Address 1", "Country", "Owner", "Status"];
export const userHeaders = ["First Name", "Last Name", "Email", "Phone"];
export const priceHeaders = ["Name"];
